module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity/brag/brag-04-e3d5876ac5b9bd10862009a63a2063ea.jpg";